import {
  BreakpointAction,
  ChoiceFunction,
  QuizDataInput,
  SexDriveChangesBreakpointOption,
} from '@naturalcycles/shared'
import { QuizPage } from '@src/app/cnst/quiz/quiz-pages.cnst'
import { addPageToFlowAfterCurrent, removePageFromFlow } from '@src/app/util/quiz.util'
import { DefaultQuizSection } from '@src/typings/quiz.enum'

const yesTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = flow => {
  return addPageToFlowAfterCurrent(
    flow,
    DefaultQuizSection.cycleChanges,
    QuizPage.cycleChangesMucusTypes,
    QuizPage.cycleChangesSexDriveAndMucusInfo,
  )
}

const noTransformFunction: ChoiceFunction<QuizPage, QuizDataInput> = flow => {
  return removePageFromFlow(
    flow,
    DefaultQuizSection.cycleChanges,
    QuizPage.cycleChangesSexDriveAndMucusInfo,
  )
}

export const cycleChangesSexDriveBreakpoint: BreakpointAction<
  SexDriveChangesBreakpointOption,
  QuizPage,
  QuizDataInput
> = {
  [SexDriveChangesBreakpointOption.variesALot]: yesTransformFunction,
  [SexDriveChangesBreakpointOption.variesALittle]: yesTransformFunction,
  [SexDriveChangesBreakpointOption.doesNotVary]: yesTransformFunction,
  [SexDriveChangesBreakpointOption.haveNotNoticed]: yesTransformFunction,
  [SexDriveChangesBreakpointOption.skip]: noTransformFunction,
}
